@if (!loading) {
  <div>
    <div class="row">
      <div class="col-4">
        <h2>Prescriber Task {{ taskId }}</h2>
      </div>
      <div class="col-8">
        <app-client-task-nav [baseUrl]="navBaseUrl" />
      </div>
    </div>
    <div>
      <app-client-task-history-item-list [historyItems]="historyItems" />
    </div>
  </div>
} @else {
  <mat-spinner />
}
